// Static brand glyphs used by the Support menu / footer. Pure SVGs — no
// runtime dependencies.

export function FacebookGlyph() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="#fff">
      <path d="M13.5 9H16V6h-2.5c-2 0-3.5 1.4-3.5 3.3V11H8v3h2v7h3v-7h2.2l.3-3H13V9.8c0-.5.2-.8.5-.8z" />
    </svg>
  );
}

export function DiscordGlyph() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="#fff">
      <path d="M19.3 5.3A16 16 0 0 0 15 4l-.2.4a13 13 0 0 0-5.6 0L9 4a16 16 0 0 0-4.3 1.3A17 17 0 0 0 2 15.4a16 16 0 0 0 4.9 2.5l.8-1.2a10 10 0 0 1-1.5-.8l.3-.3a11 11 0 0 0 11 0l.3.3-1.5.8.8 1.2a16 16 0 0 0 4.9-2.5 17 17 0 0 0-2.7-10.1zM9.3 13.7a1.8 1.8 0 1 1 0-3.6 1.8 1.8 0 0 1 0 3.6zm5.4 0a1.8 1.8 0 1 1 0-3.6 1.8 1.8 0 0 1 0 3.6z" />
    </svg>
  );
}

export function TelegramGlyph() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="#fff">
      <path d="M21.9 4.3L2.7 11.7c-1 .4-1 1-.2 1.3l4.9 1.5 1.9 5.9c.2.6.3.9.8.9.3 0 .5-.2.8-.5l2.4-2.4 5 3.7c.9.5 1.6.3 1.9-.8l3.4-16c.3-1.3-.5-1.9-1.7-1.5zM9.5 15.6l-.4 3.7-1-3 9.6-8.7-8.2 8z" />
    </svg>
  );
}

export function WhatsAppGlyph() {
  return (
    <svg width="22" height="22" viewBox="0 0 32 32" fill="#fff">
      <path d="M16 3C9 3 3.3 8.6 3.3 15.5c0 2.4.7 4.7 2 6.7L3 29l7-2.2c1.9 1 4 1.6 6.1 1.6h.01C23 28.4 28.7 22.8 28.7 16 28.7 8.6 23 3 16 3zm0 22.6h-.01c-1.9 0-3.7-.5-5.3-1.5l-.4-.2-4.2 1.3 1.3-4.1-.3-.4c-1.1-1.7-1.6-3.6-1.6-5.7 0-5.8 4.8-10.6 10.6-10.6 2.8 0 5.5 1.1 7.5 3.1s3.1 4.6 3.1 7.5c0 5.8-4.8 10.6-10.7 10.6zm5.8-7.9c-.3-.2-1.9-.9-2.2-1-.3-.1-.5-.2-.7.2s-.8 1-1 1.2c-.2.2-.4.2-.7.1-.3-.2-1.3-.5-2.5-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6.1-.1.3-.4.4-.5.1-.2.2-.3.3-.5.1-.2.1-.4 0-.5 0-.2-.7-1.6-.9-2.2-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.2.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.9-.8 2.1-1.5.3-.7.3-1.4.2-1.5-.1-.2-.3-.2-.6-.4z" />
    </svg>
  );
}

export function InstagramGlyph() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.5" cy="6.5" r="1" fill="#fff" />
    </svg>
  );
}

export function YoutubeGlyph() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="#fff">
      <path d="M21.6 7.2c-.2-.8-.8-1.4-1.6-1.6C18.5 5.2 12 5.2 12 5.2s-6.5 0-8 .4c-.8.2-1.4.8-1.6 1.6C2 8.7 2 12 2 12s0 3.3.4 4.8c.2.8.8 1.4 1.6 1.6 1.5.4 8 .4 8 .4s6.5 0 8-.4c.8-.2 1.4-.8 1.6-1.6.4-1.5.4-4.8.4-4.8s0-3.3-.4-4.8zM10 15V9l5 3-5 3z" />
    </svg>
  );
}

export function TikTokGlyph() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="#fff">
      <path d="M19 7.5a6 6 0 0 1-4.2-1.7V15a5.5 5.5 0 1 1-5.5-5.5c.3 0 .6 0 .9.1v2.6a2.9 2.9 0 1 0 2 2.8V2h2.6A4.4 4.4 0 0 0 19 4.9v2.6z" />
    </svg>
  );
}
